import { Directive, HostBinding, Input } from '@angular/core';

/**
 * enums
 */
import { ISpinKitType } from '../enums/spinkit-type';

/**
 * @abstract SpinKitDirective
 * @description
 * Abstract base directive for creating SpinKit loaders. This directive is not meant
 * to be used directly in templates. Instead, extend this class to define specific loader types.
 */
@Directive({
  selector: '[appSpinKit]',
  host: {
    'role': 'status',
    'aria-hidden': 'true',
    '[style.display]': '"block"',
  },
})
export class SpinKitDirective {


  /**
   * @access protected
   * @readonly
   * @description
   * Prefix used for building class names. Default is 'sk'.
   */
  protected readonly prefix: string = 'sk';

  /**
   * @access protected
   * @description
   * The type of the SpinKit loader. Must be set by child components.
   */
  protected type!: ISpinKitType;

  /**
   * @access public
   * @binding class
   * @description
   * Dynamically generates the class name based on the loader type.
   * @returns {string | null}
   */
  @HostBinding('class')
  public get buildClassStyle(): string | null {

    // void
    if (this.type == null) return null;

    // build class name
    return `${this.prefix}-${this.type}`;

  }


  /**
   * @input bgColor
   * @binding style.--sk-color
   * @description
   * Binds to a CSS variable to customize the loader color dynamically.
   */
  @HostBinding('style.--sk-color')
  @Input({ alias: 'bgColor' })
  public bgColor: string | null = null;

  /**
   * @constructor
   * Abstract base class constructor.
   */
  constructor() {}

  /**
   * @method createChildren
   * @access protected
   * @description
   * Generates a numeric array [1..length] to be used in ngFor for rendering loader child elements.
   * @param length number of child elements
   * @returns number[]
   */
  protected createChildren(length: number) {
    
    // empty array
    if (typeof length !== 'number' || length == 0) return [];

    // create array by length
    return Array.from({ length }, (_, i) => i + 1);

  }

}
